import {set, get} from './Storage';
function init(){
    const {GetSettings} = require('mgToolsKit');

    //import {GetSettings} from "mgUiKit";
    var AppSettings = GetSettings('TopNews',false);

    var _version = "1.0.10";
    AppSettings["version"] = _version;

    if(process.env.NODE_ENV != "production"){
        console.log("["+process.env.NODE_ENV+" environment] Starting TopNewsApp version "+_version+" ....done");        
    }

    // Default value
    if(AppSettings.isauthenticated == undefined){
        AppSettings.isauthenticated = false;
    }
    else{
        try{
            AppSettings.isauthenticated = JSON.parse(AppSettings.isauthenticated);
        }
        catch(e){
            AppSettings.isauthenticated = false;
        }
    }

    // La setto prima e dopo per renderlo disponibile in in ENV
    set(AppSettings);
    var Env = require('./Env').default;
    AppSettings["env"] = Env[process.env.NODE_ENV];

    set(AppSettings);
}

export default init();